import { useHistory } from 'react-router'
import Favorite from 'shared/components/favorite/favorite'
import { Actions, trackEvent } from 'shared/util/gif-detail-ga-events'
import css from './buttons.css'
import GifDetailAddToCollection from './gif-detail-add-to-colllection'
import styled from 'styled-components'

const FavoriteStyled = styled(Favorite)`
    width: 100%;
    margin: 0;
`

const MODES = [
    {
        label: 'Copy link',
        type: 'links',
        className: css.links,
    },
    {
        label: 'Media',
        type: 'media',
        className: css.media,
    },
    {
        label: 'Embed',
        type: 'embed',
        className: css.embed,
    },
]

const GifDetailButtons = ({ gif }) => {
    const { id, is_favorite: isFavorite, url, path } = gif
    const history = useHistory()
    const updateMode = nextMode => {
        history.replace(`${path}/${nextMode}`)
    }
    return (
        <div className={css.container}>
            <div className={css.button}>
                <FavoriteStyled
                    id={id}
                    className={css.favorite}
                    isFavorite={!!isFavorite}
                    url={url}
                    showLabel={true}
                    onClick={({ is_favorite }) => {
                        if (is_favorite) {
                            trackEvent(Actions.favorite, id)
                        }
                    }}
                />
            </div>
            {MODES.map(({ label, type, className }) => (
                <div key={type} className={css.button} onClick={() => updateMode(type)}>
                    <i className={className} />
                    <span>{label}</span>
                </div>
            ))}
            <GifDetailAddToCollection gif={gif} />
        </div>
    )
}

export default GifDetailButtons
